import React, { Component } from 'react';
import { IosToggle, FlipToggle, SkewToggle } from 'reacttoggles'
import { Tabs, Tab } from 'react-bootstrap'

const components = {
    IosToggle,
    FlipToggle,
    SkewToggle
}

const iframes = [
    `//codepen.io/nerdchacha/embed/mWBYMb/?theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/GWMavR/?theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/OpxYjy/?theme-id=dark&default-tab=js&embed-version=2`,
]

class Checked extends Component {
    constructor () {
        super()
        this.handleChange = this.handleChange.bind(this)
        this.state = {value : false}
    }
    componentDidMount () {
        setTimeout(() => this.setState({ value: true }), 5000)
    }
    handleChange (value) {
        console.log(value)
        this.setState({ value: value })
    }
    render() {
        return (
            <div className="card">
                <Tabs defaultActiveKey={0} id="uncontrolled-tab-example">
                    {Object.keys(components).map((key, i) => (
                        <Tab eventKey={i} key={i} title={key}>
                            {
                                React.createElement(components[key], {
                                    handleChange: this.handleChange,
                                    checked: this.state.value
                                })
                            }
                            <iframe
                                height='265'
                                scrolling='no'
                                title='aJyPJy'
                                src={iframes[i]}
                                frameBorder='no'
                                allowTransparency='true'
                                allowFullScreen='true'
                            >
                            </iframe>
                        </Tab>
                    ))}
                </Tabs>
                <p>value :<code>{this.state.value.toString() }</code></p>
                <p><strong>NOTE:</strong> <code>handleChange</code> will fire even on async changes</p>
            </div>
        );
    }
}

export default Checked;



// WEBPACK FOOTER //
// ./src/components/AsyncHandleChange.js